/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：783
 */

"use strict"

export { s as a }
import * as /* [auto-meaningful-name] */Module_1017 from /* 1017 */"../40/1017"
import * as /* [auto-meaningful-name] */Module_1016 from /* 1016 */"../79/1016"
import * as /* [auto-meaningful-name] */Module_782 from /* 782 */"../40/782"
import * as /* [auto-meaningful-name] */Module_1018 from /* 1018 */"../40/1018"
function s(e) {
  return Module_1017.a(e) || Module_1016.a(e) || Module_782.a(e) || Module_1018.a()
}
export default s
